import { getReservation, mapDispatchGlobal, revertReservationData } from '../../models/Reservation.model';
import { getActualDate } from '../../commons/datesUtils';

import {
  createNewTourOperationsReservation,
  getTourOperationsReservationData,
  getTourOperationsReservationAppraise,
  modifyTourOperationsReservation,
  cancelTourOperationsReservation
} from '../../commons/apiCalls';

const reservationTTOOType = 'RTTOO';

const getReservationTTOO = (index = 1, extraData = {}) => {
  const basicReservation = getReservation(index);
  const { rooms } = basicReservation;

  const { hotel, operator, locatorTTOO } = extraData;

  return {
    ...basicReservation,
    hotel,
    bookingDate: getActualDate(true),
    operator,
    locatorTTOO,
    rateCode: '',
    contract: {},
    groupId: 0,
    rooms: rooms.map((room) => ({
      ...room,
      services: []
    }))
  }
};

const mapDispatchTTOO = dispatch => ({
  ...mapDispatchGlobal(dispatch),
  loadReservationData: (
    reservationId,
    locator,
    tourOperator,
    errorCallBack
    ) => {
    dispatch(
      getTourOperationsReservationData(
        reservationId,
        locator,
        tourOperator,
        errorCallBack
      )
    )
  },
  handleBookingDate: (reservationId, bookingDate) => {
    dispatch({
      type: 'UPDATE_RESERVATION_BOOKING_DATE',
      id: reservationId,
      bookingDate
    })
  },
  handleAddService: (reservationId, roomId, service) => {
    dispatch({
      type: 'ADD_RESERVATION_SERVICE',
      id: reservationId,
      roomId,
      service
    })
  },
  handleEraseService: (reservationId, roomId, serviceId) => {
    dispatch({
      type: 'ERASE_RESERVATION_SERVICE',
      id: reservationId,
      roomId,
      serviceId
    })
  },
  handleUpdateService: (reservationId, roomId, serviceData) => {
    dispatch({
      type: 'UPDATE_RESERVATION_SERVICE_DATA',
      id: reservationId,
      roomId,
      serviceData
    })
  },
  handleUpdateServicesByDates: (reservationId, fromDate, toDate) => {
    dispatch({
      type: 'HANDLE_RESERVATION_SERVICES_BY_DATES',
      id: reservationId,
      fromDate,
      toDate
    })
  },
  handleUpdateServicesList: (reservationId, roomId, servicesList) => {
    dispatch({
      type: 'UPDATE_RESERVATION_SERVICES_LIST',
      id: reservationId,
      roomId,
      servicesList
    })
  },
  setNewReservation: (reservation, errorCallBack) => {
    const { id, operator } = reservation;

    dispatch(
      createNewTourOperationsReservation(
        id,
        operator,
        getApiReservationModel(reservation),
        errorCallBack
      )
    )
  },
  getReservationAppraise: (reservation, errorCallBack) => {
    const { id, operator } = reservation;

    dispatch(
      getTourOperationsReservationAppraise(
        id,
        operator,
        getApiReservationModel(reservation),
        errorCallBack
      )
    )
  },
  updateExistingReservation: (reservation, errorCallBack) => {
    const { id, locator, operator } = reservation;

    dispatch(
      modifyTourOperationsReservation(
        id,
        locator,
        operator,
        getApiReservationModel(reservation),
        errorCallBack
      )
    )
  },
  cancelReservation: (reservation, errorCallBack, requestCallBack) => {
    const { id, locator, operator } = reservation;

    dispatch(
      cancelTourOperationsReservation(
        id,
        locator,
        operator,
        errorCallBack,
        requestCallBack
      )
    )
  }
});

function getApiReservationModel(reservation) {
  const {
    hotel,
    bookingDate,
    fromDate,
    toDate,
    locatorTTOO,
    rateCode,
    rooms,
    comment,
    groupId
  } = reservation;

  const cleanRooms = rooms.map((room) => {
    const {
      roomCode,
      boardCode,
      distribution,
      paxes,
      services
    } = room;

    return {
      roomCode,
      boardCode,
      distribution,
      paxes: paxes.map((pax) => {
        const { name, surnames } = pax;

        return { name, surnames }
      }),
      services: services?? []
    }
  })

  return {
    hotel,
    contract: rateCode,
    bookingDate,
    fromDate,
    toDate,
    locatorTTOO,
    rooms: cleanRooms,
    comment,
    groupId
  }
}

function revertReservationTTOO(reservation, backUpData) {
  const { bookingDate, rateCode, contract } = backUpData;

  return {
    ...revertReservationData(reservation, backUpData),
    bookingDate,
    rateCode,
    contract
  }
}

export {
  reservationTTOOType,
  getReservationTTOO,
  mapDispatchTTOO,
  revertReservationTTOO,
  getApiReservationModel
};
